import React from 'react';
import { useTranslation } from 'react-i18next';
import { Photo } from '../inspection/Photo';
import { FileTextOutlined } from '@ant-design/icons';
import { SectionIcon } from '../SectionIcon';

// The registration paper and service book pages as the inspector photographed them
export const DocumentPhotos = ({ photos, onOpenImage }) => {
    const { t } = useTranslation('reportPage');

    return (
        <section id="document-photos" className="card" aria-labelledby="document-photos-title" style={{ gap: 16 }}>
            <h2 id="document-photos-title" className="h2">
                <SectionIcon icon={FileTextOutlined} />
                {t('layout.documents')}
            </h2>
            <div className="doc-grid">
                {photos.map(photo => (
                    <figure className="doc-photo" key={photo.url}>
                        <figcaption className="eyebrow">{photo.label}</figcaption>
                        <Photo photo={photo} onOpen={onOpenImage} />
                    </figure>
                ))}
            </div>
        </section>
    );
};
